import { render } from "./Investers.vue?vue&type=template&id=84ea85b6&scoped=true"
import script from "./Investers.vue?vue&type=script&lang=js"
export * from "./Investers.vue?vue&type=script&lang=js"

import "./Investers.vue?vue&type=style&index=0&id=84ea85b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ea85b6"]])

export default __exports__